@use "../../sass/global/global" as *;

.ux-iws-teaser-counter {
    display: block;
    text-align: center;

    &__number {
        @include font(bold);
        font-size: 34px;

        @media only screen and (min-width: 1440px) {
            font-size: 44px;
        }
    }

    hr {
        border: 0;
        background: #e2e2e2;
        background-image: linear-gradient(to right, #f6f6f6, #e2e2e2, #f6f6f6);
    }

    &__separator {
        display: block;
        margin: 10px;

        @media only screen and (min-width: 1024px) {
            margin-bottom: 20px;
        }
    }
}

.ux-iws-teaser-counter-grid {
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: 768px) {
        flex-direction: row;
        justify-content: center;

        > * {
            flex: 0 0 33%;
        }
    }
}
